export default __webpack_public_path__ + "static/media/whatsapp-social-media.3a64c778.svg";